const styles = {
  colorSelect: {},
  option: {
    cursor: 'pointer',
    display: 'block',
    height: '40px'
  },
  value: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: 'calc(100% - 30px)',
    height: '100%',
    borderRight: '1px solid #DDD'
  }
}

export default styles
